import React, { useState, useEffect } from 'react';
import { apiFetch } from './api';

const passwortValidieren = (pw) => {
  if (pw.length < 12) return 'Mindestens 12 Zeichen';
  if (!/[A-Z]/.test(pw)) return 'Mindestens ein Großbuchstabe';
  if (!/[a-z]/.test(pw)) return 'Mindestens ein Kleinbuchstabe';
  if (!/[0-9]/.test(pw)) return 'Mindestens eine Zahl';
  if (!/[^A-Za-z0-9]/.test(pw)) return 'Mindestens ein Sonderzeichen';
  return null;
};

const Team = ({ user }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOffen, setFormOffen] = useState(false);
  const [bearbeiten, setBearbeiten] = useState(null);
  const [fehler, setFehler] = useState('');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [position, setPosition] = useState('');
  const [passwort, setPasswort] = useState('');
  const [role, setRole] = useState('member');

  const [passwortPopup, setPasswortPopup] = useState(null);
  const [altesPasswort, setAltesPasswort] = useState('');
  const [neuesPasswort, setNeuesPasswort] = useState('');
  const [neuesPasswort2, setNeuesPasswort2] = useState('');
  const [passwortFehler, setPasswortFehler] = useState('');
  const [passwortErfolg, setPasswortErfolg] = useState(false);

  const istAdmin = user.role === 'admin';

  const ladeUsers = async () => {
    const response = await apiFetch('/users');
    const data = await response.json();
    setUsers(data);
    setLoading(false);
  };

  useEffect(() => { ladeUsers(); }, []);

  const reset = () => {
    setName(''); setEmail(''); setPosition(''); setPasswort('');
    setRole('member'); setFormOffen(false); setBearbeiten(null); setFehler('');
  };

  const passwortPopupReset = () => {
    setPasswortPopup(null); setAltesPasswort(''); setNeuesPasswort('');
    setNeuesPasswort2(''); setPasswortFehler(''); setPasswortErfolg(false);
  };

  const mitarbeiterErstellen = async () => {
    setFehler('');
    if (!name || !email || !passwort) { setFehler('Name, Email und Passwort sind pflicht'); return; }
    const pwFehler = passwortValidieren(passwort);
    if (pwFehler) { setFehler(pwFehler); return; }
    const response = await fetch('https://os.studio-soma.de/api/auth/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password: passwort, position, role })
    });
    const data = await response.json();
    if (!response.ok) { setFehler(data.error); return; }
    reset(); ladeUsers();
  };

  const mitarbeiterSpeichern = async () => {
    setFehler('');
    if (!name || !email) { setFehler('Name und Email sind pflicht'); return; }
    await apiFetch(`/users/${bearbeiten.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, position, role })
    });
    reset(); ladeUsers();
  };

  const passwortAendern = async () => {
    setPasswortFehler('');
    const istEigenes = passwortPopup.id === user.id;
    const istAdminReset = istAdmin && !istEigenes;

    if (!neuesPasswort || !neuesPasswort2) {
      setPasswortFehler('Neues Passwort ausfüllen'); return;
    }
    if (istEigenes && !altesPasswort) {
      setPasswortFehler('Altes Passwort eingeben'); return;
    }
    if (neuesPasswort !== neuesPasswort2) {
      setPasswortFehler('Neue Passwörter stimmen nicht überein'); return;
    }
    const pwFehler = passwortValidieren(neuesPasswort);
    if (pwFehler) { setPasswortFehler(pwFehler); return; }

    let res;
    if (istAdminReset) {
      res = await apiFetch(`/users/${passwortPopup.id}/passwort-reset`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ neuesPasswort })
      });
    } else {
      res = await apiFetch(`/users/${passwortPopup.id}/passwort`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ altesPasswort, neuesPasswort })
      });
    }
    const data = await res.json();
    if (!res.ok) { setPasswortFehler(data.error); return; }
    setPasswortErfolg(true);
    setTimeout(() => passwortPopupReset(), 2000);
  };

  const mitarbeiterLoeschen = async (id) => {
    await apiFetch(`/users/${id}`, { method: 'DELETE' });
    ladeUsers();
  };

  const bearbeitenOeffnen = (u) => {
    setBearbeiten(u); setName(u.name); setEmail(u.email);
    setPosition(u.position || ''); setRole(u.role);
    setFormOffen(false); setFehler('');
  };

  const inputStyle = {
    width: '100%', padding: '10px 14px', fontSize: '14px',
    border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none', boxSizing: 'border-box'
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b',
    marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px'
  };

  const zeigeForm = formOffen || bearbeiten;
  const istAdminReset = passwortPopup && istAdmin && passwortPopup.id !== user.id;

  return (
    <div style={{ padding: '40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '32px' }}>
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>Team</h2>
          <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>
            {users.length} {users.length === 1 ? 'Mitglied' : 'Mitglieder'}
          </p>
        </div>
        {istAdmin && (
          <button onClick={() => { reset(); setFormOffen(true); }} style={{
            padding: '8px 16px', backgroundColor: '#1a1a1a', color: '#ffffff', border: 'none',
            borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
          }}>+ Mitarbeiter</button>
        )}
      </div>

      {istAdmin && zeigeForm && (
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px', padding: '24px', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 16px 0' }}>
            {bearbeiten ? 'Mitarbeiter bearbeiten' : 'Neuer Mitarbeiter'}
          </h3>
          {fehler && (
            <div style={{ padding: '10px 14px', backgroundColor: '#fff0f0', border: '1px solid #ffdddd', borderRadius: '8px', color: '#cc0000', fontSize: '13px', marginBottom: '16px' }}>
              {fehler}
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
            <div>
              <label style={labelStyle}>Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Magdalena Müller" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Position</label>
              <input type="text" value={position} onChange={(e) => setPosition(e.target.value)} placeholder="Junior Producerin" style={inputStyle} />
            </div>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@studio.de" style={inputStyle} />
          </div>
          {!bearbeiten && (
            <div style={{ marginBottom: '4px' }}>
              <label style={labelStyle}>Passwort</label>
              <input type="password" value={passwort} onChange={(e) => setPasswort(e.target.value)} placeholder="Startpasswort" style={inputStyle} />
              <p style={{ fontSize: '11px', color: '#9b9b9b', margin: '6px 0 12px 0' }}>
                Min. 12 Zeichen, Groß- & Kleinbuchstaben, Zahl, Sonderzeichen
              </p>
            </div>
          )}
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Rolle</label>
            <select value={role} onChange={(e) => setRole(e.target.value)} style={inputStyle}>
              <option value="member">Mitarbeiter</option>
              <option value="admin">Administrator</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={bearbeiten ? mitarbeiterSpeichern : mitarbeiterErstellen} style={{
              padding: '8px 20px', backgroundColor: '#1a1a1a', color: '#ffffff', border: 'none',
              borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
            }}>{bearbeiten ? 'Speichern' : 'Erstellen'}</button>
            <button onClick={reset} style={{
              padding: '8px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
              border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
            }}>Abbrechen</button>
          </div>
        </div>
      )}

      {loading ? (
        <p style={{ color: '#9b9b9b', fontSize: '14px' }}>Lädt...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {users.map((u) => (
            <div key={u.id} style={{
              backgroundColor: '#ffffff', borderRadius: '10px', padding: '16px 24px',
              border: '1px solid #efefef', display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{
                  width: '38px', height: '38px', borderRadius: '50%', backgroundColor: '#f0f0ee',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '15px', fontWeight: '600', color: '#6b6b6b'
                }}>{u.name.charAt(0).toUpperCase()}</div>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 2px 0' }}>
                    {u.name}
                    {u.role === 'admin' && (
                      <span style={{
                        fontSize: '10px', fontWeight: '600', color: '#6b6b6b', backgroundColor: '#f0f0ee',
                        padding: '2px 6px', borderRadius: '4px', marginLeft: '8px',
                        textTransform: 'uppercase', letterSpacing: '0.5px'
                      }}>Admin</span>
                    )}
                  </p>
                  <p style={{ fontSize: '12px', color: '#9b9b9b', margin: 0 }}>
                    {u.position ? u.position + ' · ' : ''}{u.email}
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {(u.id === user.id || istAdmin) && (
                  <button onClick={() => setPasswortPopup(u)} style={{
                    padding: '4px 10px', backgroundColor: 'transparent', border: '1px solid #e8e8e8',
                    borderRadius: '6px', fontSize: '11px', color: '#6b6b6b', cursor: 'pointer'
                  }}>Passwort</button>
                )}
                {istAdmin && (
                  <button onClick={() => bearbeitenOeffnen(u)} style={{
                    padding: '4px 10px', backgroundColor: 'transparent', border: '1px solid #e8e8e8',
                    borderRadius: '6px', fontSize: '11px', color: '#6b6b6b', cursor: 'pointer'
                  }}>Bearbeiten</button>
                )}
                {istAdmin && u.id !== user.id && (
                  <button onClick={() => mitarbeiterLoeschen(u.id)} style={{
                    padding: '4px 10px', backgroundColor: 'transparent', border: '1px solid #ffdddd',
                    borderRadius: '6px', fontSize: '11px', color: '#cc0000', cursor: 'pointer'
                  }}>Löschen</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {passwortPopup && (
        <div onClick={passwortPopupReset} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.35)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            backgroundColor: '#ffffff', borderRadius: '14px', width: '100%', maxWidth: '420px',
            padding: '32px', boxShadow: '0 12px 48px rgba(0,0,0,0.18)'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.3px' }}>
              {istAdminReset ? 'Passwort zurücksetzen' : 'Passwort ändern'}
            </h3>
            <p style={{ fontSize: '13px', color: '#9b9b9b', margin: '0 0 24px 0' }}>
              {passwortPopup.name}
              {istAdminReset && <span style={{ marginLeft: '6px', fontSize: '11px', color: '#c4c4c4' }}>(Admin-Reset, kein altes Passwort nötig)</span>}
            </p>

            {passwortErfolg ? (
              <div style={{ padding: '14px', backgroundColor: '#f0fff4', border: '1px solid #c6f6d5', borderRadius: '8px', color: '#276749', fontSize: '14px', textAlign: 'center' }}>
                ✓ Passwort erfolgreich {istAdminReset ? 'zurückgesetzt' : 'geändert'}
              </div>
            ) : (
              <>
                {passwortFehler && (
                  <div style={{ padding: '10px 14px', backgroundColor: '#fff0f0', border: '1px solid #ffdddd', borderRadius: '8px', color: '#cc0000', fontSize: '13px', marginBottom: '16px' }}>
                    {passwortFehler}
                  </div>
                )}
                {!istAdminReset && (
                  <div style={{ marginBottom: '12px' }}>
                    <label style={labelStyle}>Altes Passwort</label>
                    <input type="password" value={altesPasswort} onChange={(e) => setAltesPasswort(e.target.value)} style={inputStyle} />
                  </div>
                )}
                <div style={{ marginBottom: '12px' }}>
                  <label style={labelStyle}>Neues Passwort</label>
                  <input type="password" value={neuesPasswort} onChange={(e) => setNeuesPasswort(e.target.value)} style={inputStyle} />
                  <p style={{ fontSize: '11px', color: '#9b9b9b', margin: '6px 0 0 0' }}>
                    Min. 12 Zeichen, Groß- & Kleinbuchstaben, Zahl, Sonderzeichen
                  </p>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <label style={labelStyle}>Neues Passwort wiederholen</label>
                  <input type="password" value={neuesPasswort2} onChange={(e) => setNeuesPasswort2(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') passwortAendern(); }}
                    style={inputStyle} />
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={passwortAendern} style={{
                    padding: '10px 20px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
                    borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
                  }}>{istAdminReset ? 'Zurücksetzen' : 'Ändern'}</button>
                  <button onClick={passwortPopupReset} style={{
                    padding: '10px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
                    border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
                  }}>Abbrechen</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Team;